import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import teamWorkImage from 'assets/images/liheap-banner.jpeg';
import styles from './programs.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const REPORT_DATA = [
  {
    title: '',
    items: [
      'LIHEAP Performance Measures',
      'Energy Burden Targeting',
      'Application Status Reports',
      'County Summary Reports',
      'Available Funds (Usage and Balance)',
    ],
  },
  {
    title: '',
    items: [
      'Paid vs. Unpaid Applications',
      'Priority Listing',
      'Weatherization Referrals',
      'Energy Education Services',
    ],
  },
];
const FEATURE_DATA = [
  {
    id: '01',
    title: 'Program Eligibility Calculator',
  },
  {
    id: '02',
    title: 'Priority Point Matrix',
  },
  {
    id: '03',
    title: 'Benefit Amount Calculation',
  },
  {
    id: '04',
    title: 'Automated Payment Creation',
  },
  {
    id: '05',
    title: 'Real-time Status Tracking',
  },
  {
    id: '06',
    title: 'Complete Integration with Other Agency Programs',
  },
  {
    id: '07',
    title: 'Integrated Check Printing System',
  },
  {
    id: '08',
    title: 'Automated Transmittal to Utility Vendors',
  },
  {
    id: '09',
    title: 'Track Energy Outreach Activities',
  },
  {
    id: '10',
    title: 'Unduplicated Client Count',
  },

  // {
  //   id: '11',
  //   title: 'Complete Integration with Other Agency Programs',
  // },
  // {
  //   id: '12',
  //   title: 'Real-time Status Tracking',
  // },
];
function Liheap() {
  return (
    <div>
      <Helmet>
        <title>Extensive LIHEAP Record Keeping - CAP60</title>
        <meta
          name="description"
          content="The CAP60 LIHEAP module is a web-based software solution designed to help agencies and state government offices manage the federal low income home energy assistance program."
        />
        <meta name="keywords" content="liheap, cap60 liheap" />
      </Helmet>
      <PageBanner
        title="LIHEAP"
        subtitle="Extensive LIHEAP Record Keeping and Reporting System"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>Extensive LIHEAP Record Keeping and Reporting System</h2>
          </div>
          <p>
            The CAP60 LIHEAP module is a web-based software solution designed to
            help agencies and state government offices manage the federal Low
            Income Home Energy Assistance Program (LIHEAP).
          </p>
          <p>
            CAP60 offers automated data collection, utility payment management
            and reporting in an intuitive user interface. The CAP60 solution
            increases data accuracy, improves program integrity, simplifies
            reporting and eliminates paperwork while improving program
            coordination, efficiency and productivity. This solution is fully
            integrated with CAP60 Agency Wide Data Management System.
          </p>
          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

function SampleReport() {
  return (
    <div className={styles.sampleReportWrapper}>
      <Container>
        <div className="heading">
          <h2>Reports</h2>
        </div>
        <Row>
          {REPORT_DATA.map((rdata, idx) => (
            <Col md="6" key={idx}>
              <div className={styles.reportList}>
                <h3>{rdata.title}</h3>
                <ul>
                  {rdata.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default Liheap;
